import { Search } from "lucide-react";
import { categoryOptions, label, severityOptions } from "./activityMeta";

export default function ActivityToolbar({ filters, onChange, onClear }) {
  return (
    <div className="activity-toolbar">
      <label className="activity-search">
        <Search size={17} />
        <input
          value={filters.search}
          onChange={(event) => onChange("search", event.target.value)}
          placeholder="Search activity"
        />
      </label>

      <select value={filters.category} onChange={(event) => onChange("category", event.target.value)}>
        <option value="">All categories</option>
        {categoryOptions.map((value) => (
          <option key={value} value={value}>{label(value)}</option>
        ))}
      </select>

      <input
        value={filters.activity_type}
        onChange={(event) => onChange("activity_type", event.target.value)}
        placeholder="Activity type"
      />

      <select value={filters.severity} onChange={(event) => onChange("severity", event.target.value)}>
        <option value="">All severity</option>
        {severityOptions.map((value) => (
          <option key={value} value={value}>{label(value)}</option>
        ))}
      </select>

      <input type="date" value={filters.date_from} onChange={(event) => onChange("date_from", event.target.value)} />
      <input type="date" value={filters.date_to} onChange={(event) => onChange("date_to", event.target.value)} />

      <select value={filters.ordering} onChange={(event) => onChange("ordering", event.target.value)}>
        <option value="-created_at">Newest</option>
        <option value="created_at">Oldest</option>
        <option value="severity">Severity</option>
        <option value="category">Category</option>
      </select>

      <button type="button" className="btn btn--secondary" onClick={onClear}>Clear</button>
    </div>
  );
}